import { Config } from './config';

/* On the clint we use config built on Tokamak */
export const config = global.__PRELOADED_CONFIG__ as Config;

__webpack_public_path__ = `${config.cdnDomain}${__webpack_public_path__}`;
